import {LocationInfoVM} from "./LocationInfoVM.model";

export class PersonInfoVM {
  id:number;
  location:LocationInfoVM = new LocationInfoVM();
  fisrtName:string;
  lastName:string;
  phoneNumber:string;

  birthDate: any;
  email: string;
  gender: boolean;
  image: any;
  nationalCode: string;
  socialNetworkInfos: string;

  constructor() {

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/PersonInfoVM.model.ts